import { ALL_DELIVERY_COMPLETED_BACKGROUND_URL } from '../../map_screen/all_delivery_completed/allDeliveryCompletedAssets';
import {
  ALL_DELIVERY_COMPLETED_LAYOUT,
  ALL_DELIVERY_COMPLETED_SIZE,
} from '../../map_screen/all_delivery_completed/allDeliveryCompletedLayout';
import '../../map_screen/all_delivery_completed/AllDeliveryCompletedModal.css';
import { useMoscowCountdown } from '../../../hooks/useMoscowCountdown';
import './QuizDailyLimitModal.css';

export const QUIZ_DAILY_LIMIT_TITLE = 'На сегодня вопросы закончились!';
export const QUIZ_DAILY_LIMIT_BODY =
  'Пока можешь копить улётные билеты и выполнять доставки';

export type QuizDailyLimitModalProps = {
  onZero?: () => void;
};

/** Same frame and Moscow countdown as the map «all deliveries done» overlay. */
export function QuizDailyLimitModal({ onZero }: QuizDailyLimitModalProps) {
  const { titleText, bodyText, countdown } = ALL_DELIVERY_COMPLETED_LAYOUT;
  const countdownLabel = useMoscowCountdown(onZero);

  return (
    <div
      className="all-delivery-completed-modal"
      role="dialog"
      aria-modal="true"
      aria-label={QUIZ_DAILY_LIMIT_TITLE}
    >
      <div className="all-delivery-completed-modal__backdrop" aria-hidden />
      <div
        className="all-delivery-completed-modal__frame"
        style={{
          width: ALL_DELIVERY_COMPLETED_SIZE.width,
          height: ALL_DELIVERY_COMPLETED_SIZE.height,
        }}
      >
        <img
          className="all-delivery-completed-modal__background"
          src={ALL_DELIVERY_COMPLETED_BACKGROUND_URL}
          alt=""
          draggable={false}
          aria-hidden
        />
        <p
          className="quiz-daily-limit-modal__title"
          style={{
            left: titleText.left,
            top: titleText.top,
            width: titleText.width,
            height: titleText.height,
          }}
        >
          {QUIZ_DAILY_LIMIT_TITLE}
        </p>
        <p
          className="all-delivery-completed-modal__countdown"
          aria-live="polite"
          style={{
            left: countdown.left,
            top: countdown.top,
            width: countdown.width,
            height: countdown.height,
          }}
        >
          {countdownLabel}
        </p>
        <p
          className="quiz-daily-limit-modal__body"
          style={{
            left: bodyText.left,
            top: bodyText.top,
            width: bodyText.width,
            height: bodyText.height,
          }}
        >
          {QUIZ_DAILY_LIMIT_BODY}
        </p>
      </div>
    </div>
  );
}
